import React from "react"
import logo from "../assets/logo.png"
import about1 from "../assets/about1.jpg"
import about2 from "../assets/about2.jpg"
import team1 from "../assets/team1.jpg"
import team2 from "../assets/team2.jpg"
import team3 from "../assets/team3.jpg"

export const About = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="container mx-auto px-6 pt-16">
        <div className="w-full flex justify-center animate-fade-in">
          <img
            src={logo}
            alt="logo"
            className="w-50 h-30 object-cover object-center"
          />
        </div>
        <h2 className="text-4xl font-semibold text-gray-800 animate-fade-in text-center mb-12">
          About Modular Home: Building the Future of Home
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {/* Left Column: Our Story */}
          <div className="animate-slide-in-left">
            <img
              src={about1}
              alt="A diverse team of architects and engineers collaborating on a modular home design."
              className="w-full rounded-2xl shadow-lg mb-8"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Our Story: From Vision to Reality
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Modular Home was founded on a simple yet powerful vision: to
              revolutionize the way homes are designed and built. We saw an
              opportunity to combine innovative modular construction techniques
              with a commitment to sustainability and personalized design,
              creating homes that are not only beautiful and functional but also
              environmentally responsible and affordable.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Our journey began with a small team of passionate architects,
              engineers, and construction professionals who shared a common
              goal: to challenge the status quo and create a better future for
              housing. We spent years researching and developing our modular
              construction system, perfecting every detail to ensure the highest
              levels of quality, efficiency, and sustainability.
            </p>
          </div>

          {/* Right Column: Our Mission and Values */}
          <div className="animate-slide-in-right">
            <img
              src={about2}
              alt="A modern modular home blending seamlessly with a natural landscape, showcasing sustainable design."
              className="w-full rounded-2xl shadow-lg mb-8"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Our Mission: Creating Sustainable and Personalized Homes
            </h3>
            <p className="text-gray-700 leading-relaxed">
              At Modular Home, our mission is to empower individuals and
              families to live in homes that are both beautiful and sustainable.
              We believe that everyone deserves access to high-quality,
              affordable housing that minimizes its impact on the environment.
            </p>
            <h4 className="text-xl font-semibold text-gray-800 mt-6 mb-2">
              Our Core Values:
            </h4>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed">
              <li>
                Innovation: We are constantly seeking new and better ways to
                design and build homes.
              </li>
              <li>
                Sustainability: We are committed to minimizing our environmental
                footprint.
              </li>
              <li>
                Quality: We strive for excellence in every aspect of our work.
              </li>
              <li>
                Personalization: We believe that every home should be a
                reflection of its owner.
              </li>
              <li>
                Affordability: We are dedicated to making high-quality housing
                accessible to all.
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section: Our Team */}
        <div className="mt-16">
          <h3 className="text-3xl font-semibold text-gray-800 text-center mb-8">
            Meet Our Team
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Team Member 1 */}
            <div className="transition-all duration-700 ease-in-out text-center hover:scale-110">
              <img
                src={team1}
                alt="Portrait of John Doe, CEO of Modular Home."
                className="w-48 h-48 rounded-full object-cover mx-auto mb-4 shadow-md"
              />
              <h4 className="text-xl font-semibold text-gray-800">John Doe</h4>
              <p className="text-gray-600">CEO</p>
            </div>

            {/* Team Member 2 */}
            <div className="transition-all duration-700 ease-in-out text-center hover:scale-110">
              <img
                src={team2}
                alt="Portrait of Jane Smith, Head of Design."
                className="w-48 h-48 rounded-full object-cover mx-auto mb-4 shadow-md"
              />
              <h4 className="text-xl font-semibold text-gray-800">
                Wayne Smith
              </h4>
              <p className="text-gray-600">Head of Design</p>
            </div>

            {/* Team Member 3 */}
            <div className="transition-all duration-700 ease-in-out text-center hover:scale-110">
              <img
                src={team3}
                alt="Portrait of David Lee, Head of Construction."
                className="w-48 h-48 rounded-full object-cover mx-auto mb-4 shadow-md"
              />
              <h4 className="text-xl font-semibold text-gray-800">
                Lana Matters
              </h4>
              <p className="text-gray-600">Head of Construction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
